const profileValidationPT = {
    "email": {
        "required": "O endereço de e-mail é obrigatório"
    },
    "profile_image": {
        "dimensions": "O tamanho da imagem de perfil deve ser exatamente 300 x 300 px, JPG/JPEG. Tamanho máximo do arquivo 300 KB",
        "choose": "Por favor, escolha uma imagem",
        "file": "O arquivo selecionado é maior que 300 KB. Por favor, carregue a capa em 300x300 px, JPG/JPEG, tamanho máximo do arquivo 300 KB."
    },
    "street_and_number": {
        "required": "A rua e o número da casa são obrigatórios"
    },
    "postal_code": {
        "required": "O código postal é obrigatório"
    },
    "city": {
        "required": "A cidade é obrigatória"
    },
    "country": {
        "required": "O país é obrigatório"
    },
    "vat_number": {
        "invalid": "O valor não é um número de IVA válido"
    },
    "iban": {
        "required": "IBAN é obrigatório",
        "invalid": "O valor não é um número IBAN válido"
    },
    "cardholder_name": {
        "required": "O nome do titular do cartão é obrigatório"
    },
    "card_number": {
        "required": "O número do cartão é obrigatório",
        "invalid": "O número do cartão não é válido"
    },
    "card_year": {
        "required": "O ano de validade é obrigatório",
        "invalid": "O ano de validade não é válido"
    },
    "card_month": {
        "required": "O mês de validade é obrigatório"
    },
    "cvc_code": {
        "required": "O código de segurança (CVC) é obrigatório",
        "invalid": "O código de segurança (CVC) não é válido"
    },
    "paypal_email": {
        "required": "O e-mail do Paypal é obrigatório",
        "invalid": "O e-mail do Paypal não é válido"
    },
    "account_holder_name": {
        "required": "O nome do titular da conta bancária é obrigatório"
    },
    "bank_name": {
        "required": "O nome do banco é obrigatório"
    },
    "bank_address": {
        "required": "O endereço do banco é obrigatório"
    },
    "preferred_payment_method": {
        "required": "O método de pagamento preferido é obrigatório"
    }
};

export default profileValidationPT;